const Promise = require('bluebird');
const Reflux = require('@muzzylane/reflux');

const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const ServerRequest = require('./request');
const CourseWebsocket = require('../util/CourseWebsocket');

const CourseWebsocketActions = Reflux.createActions({
    getCourseLock: { children: ['completed', 'failed'] },
    releaseCourseLock: { children: ['completed', 'failed'] },
    refreshCourseLock: { children: ['completed', 'failed'] },
    reestablishCourseLock: { children: ['completed', 'failed'] },
    resetStore: { children: ['completed'] },
    ensureLockReleased: { children: [] },
    devTestWSDisconnect: { children: ['completed'] },
});

CourseWebsocketActions.getCourseLock.listen(function(actionId, params) {
    if (
        !params.userId
        || !params.courseId
    ) {
        this.failed(actionId, null, params.courseId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    const cWebsocket = new CourseWebsocket(params);
    cWebsocket.connectAuthLock()
        .then(res => this.completed(actionId, cWebsocket))
        .catch(err =>  this.failed(actionId, cWebsocket, params.courseId, err));
});

CourseWebsocketActions.releaseCourseLock.listen(function(actionId, params) {
    if (!params.cWebsocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.cWebsocket.releaseLock()
        .then(res => this.completed(actionId, params.cWebsocket.courseId))
        .catch(err => this.failed(actionId, err));
});

CourseWebsocketActions.refreshCourseLock.listen(function(actionId, params) {
    if (!params.cWebsocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.cWebsocket.refreshLock()
        .then(res => this.completed(actionId, params.cWebsocket))
        .catch(err => this.failed(actionId, err));
});

CourseWebsocketActions.reestablishCourseLock.listen(function(actionId, params) {
    if (!params.cWebsocket) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.INVALID_INPUT }));
        return;
    }

    params.cWebsocket.connectAuthLock(true)
        .then(res =>  this.completed(actionId, params.cWebsocket))
        .catch(err => this.failed(actionId, params.courseId, err));
});

CourseWebsocketActions.resetStore.listen(function(actionId, params) {
    this.completed(actionId, params.lockProcessBegun);
});

CourseWebsocketActions.ensureLockReleased.listen(function(actionId, params) {
    if (
        !!params
        && !!params.cWebsocket
        && !!params.cWebsocket._haveLock
        && !params.connectionLost
    ) {
        CourseWebsocketActions.releaseCourseLock(actionId, params);
    }
    else {
        CourseWebsocketActions.resetStore(actionId, params);
    }
});

if (GlobalConfig.DevMode) {
    CourseWebsocketActions.devTestWSDisconnect.listen(function() { this.completed() })
}
else {
    CourseWebsocketActions.devTestWSDisconnect.listen(() => { return })
}

module.exports = CourseWebsocketActions;